import create from 'zustand';

export const useDrawerStore = create(set => ({
    isOpen: false,
    setOpen: (value) => set(state => ({isOpen: value})),
}))